import { useSelector, useDispatch } from "react-redux"

const useAddDiscountModal = () => {
    const dispatch = useDispatch()
    const reduxData = useSelector((state) => state.modal.counseling.addDiscountModal)
    const {isOpen, onChange} = reduxData
    const setOpen = (open, onChange = () => {}) => {
        dispatch({
            type: 'SET_DATA_MODAL_FORM_LIST',
            payload: 'counseling.addDiscountModal',
            data: {
                ...reduxData,
                isOpen: open,
                onChange
            }
        })
    }
    return {
        isOpen,
        onChange,
        open: (onChange = () => {}) => {setOpen(true, onChange)},
        close: () => {setOpen(false)},
        toggle: () => {setOpen(!isOpen)},
    }
}

export default useAddDiscountModal